<template>
    <form @submit.prevent="onSubmit">
        <div class="form-group"
             v-for="creditPackage in creditPackages"
             :key="creditPackage.id"
        >
            <label>Pacote #{{ creditPackage.id }}</label>
            <div class="flex-row">
                <p type="text"
                    class="form-control"
                    v-text="creditPackage.amount"
                    :disabled="true"
                ></p>
                <h2 class="m-l m-r">R$</h2>
                <p type="text"
                    class="form-control"
                    v-text="creditPackage.price"
                    :disabled="true"
                ></p>
                <h2 class="m-l m-r">V.C</h2>
                <p type="text"
                    class="form-control"
                    v-text="creditPackage.vindi_product_id"
                    :disabled="true"
                ></p>
                <button class="btn btn-default m-l m-b-sm"
                        type="button"
                        @click="changeVisibility(creditPackage)"
                > <i v-if="creditPackage.visible" class="fa fa-eye"></i>
                    <i v-else="creditPackage.visible" class="fa fa-eye-slash"></i>
                </button>
                <button class="btn btn-danger m-l m-b-sm"
                        type="button"
                        @click="deletePackage(creditPackage)"
                >x</button>
            </div>
        </div>
        <label>Novo Pacote</label>
        <div class="flex-row">
            <div class="form-group"
                 :class="{ 'has-error': form.errors.has('amount') }">
                <input type="text"
                    class="form-control"
                    v-model="form.amount"
                    placeholder="Total de créditos"
                >
            </div>
            <h2 class="m-l m-r">R$</h2>
            <div class="form-group"
                 :class="{ 'has-error': form.errors.has('price') }">
                <input type="text"
                       placeholder="Custo do pacote"
                       class="form-control"
                       v-model="form.price"
                >
            </div>
            <button class="btn btn-primary m-l m-b"
                        type="button"
                        @click="onSubmit"
                >x</button>
        </div>
        <div class="form-group">
            <button type="submit" class="btn btn-md btn-primary">Adicionar Novo</button>
        </div>
    </form>
</template>

<script>
import Form from 'form-backend-validation';

export default {
    props: {
        partnership: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            creditPackages: [],
            form: new Form({
                amount: null,
                price: null,
                partnership_id: null,
            }),
        };
    },
    mounted() {
        this.loadCreditPackages();
    },
    methods: {
        loadCreditPackages() {

            // verifica se tem partnership
            if ( this.partnership )
            {
                this.form.partnership_id = this.partnership.id;
            }

            if ( this.partnership ) {
                axios.get(`/credit-packages/${this.partnership.id}/partnership`)
                    .then(({data}) => {
                        this.creditPackages = data;
                    });
            }
            else  {
                axios.get('/credit-packages')
                    .then(({data}) => {
                        this.creditPackages = data;
                    });
            }
        },
        onSubmit() {
            this.form.post('/credit-packages')
                .then(() => {
                    this.loadCreditPackages();
                });
        },
        deletePackage(creditPackage) {
            axios.delete(`/credit-packages/${creditPackage.id}`)
                .then(() => {
                    this.loadCreditPackages();
                })
                .catch(() => {
                    toastr.error('Erro ao excluir o pacote de créditos');
                });
        },
        changeVisibility(creditPackage) {
            axios.post(`/credit-packages/${creditPackage.id}/visibility`)
                .then(() => {
                    this.loadCreditPackages();
                })
                .catch(() => {
                    toastr.error('Erro ao mudar o pacote de créditos');
                });
        }
    },
}
</script>
